import { createActionGroup, props } from '@ngrx/store';

export const LanguageActions = createActionGroup({
  source: 'Language',
  events: {
    '[Language] Change': props<{ language: string }>(),
  },
});
